/* Keep the managed CPB app block inert until the shopper requests customization. */
(() => {
  const template = document.querySelector('template[data-gp-builder-template]');
  if (!template) return;
  const host = template.parentElement;
  let loading;
  let loaded = false;
  let failed = false;
  const status = document.createElement('div');
  status.className = 'gp-builder-loading';
  status.hidden = true;
  const message = document.createElement('p');
  message.setAttribute('role', 'status');
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.className = 'button';
  retry.textContent = 'Retry loading customiser';
  retry.hidden = true;
  const cancel = document.createElement('button');
  cancel.type = 'button';
  cancel.className = 'button';
  cancel.textContent = 'Cancel';
  status.append(message, retry, cancel);
  // CPB owns the loading screen; attach this panel only on a genuine failure.
  cancel.addEventListener('click', () => {
    document.querySelector('[data-frame-open-builder]')?.focus();
    document.dispatchEvent(new CustomEvent('gp:builder-cancel'));
  });
  document.addEventListener('gp:frame-builder-visibility', event => {
    const visible = failed && event.detail.visible;
    status.hidden = !visible;
    status.style.display = visible ? 'block' : 'none';
  });
  function runScript({ source, anchor }) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      for (const attr of source.attributes) script.setAttribute(attr.name, attr.value);
      if (source.src) {
        script.async = false;
        script.onload = resolve;
        script.onerror = () => reject(new Error('Customiser script could not load.'));
      } else script.textContent = source.textContent;
      anchor.replaceWith(script);
      if (!script.src) resolve();
    });
  }
  let stylesReady;
  function loadStyles() {
    if (!template.dataset.gpBuilderStyles) return Promise.resolve();
    if (stylesReady) return stylesReady;
    stylesReady = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = template.dataset.gpBuilderStyles;
      link.onload = resolve;
      link.onerror = () => reject(new Error('Customiser styles could not load.'));
      document.head.append(link);
    });
    return stylesReady;
  }
  function mount() {
    const fragment = template.content.cloneNode(true);
    const scripts = [...fragment.querySelectorAll('script')].map(source => {
      const anchor = document.createComment('Deferred CPB script');
      source.replaceWith(anchor);
      return { source, anchor };
    });
    // The app's legacy personalisation bootstrap owns this local target instead
    // of replacing the native product form used for basic frame purchasing.
    const legacyTarget = document.createElement('div');
    legacyTarget.className = 'cpb-payment-buttons';
    legacyTarget.hidden = true;
    fragment.prepend(legacyTarget);
    host.append(fragment);
    return scripts;
  }
  function load() {
    if (loaded) return Promise.resolve();
    if (loading) return loading;
    status.hidden = true;
    failed = false;
    retry.hidden = true;
    loading = (async () => {
      await loadStyles();
      const scripts = mount();
      const mounted = new Promise((resolve, reject) => {
        const finish = () => { clearTimeout(timer); document.body.removeEventListener('CPB_ON_PRODUCT_MOUNTED', finish); resolve(); };
        const timer = setTimeout(() => { document.body.removeEventListener('CPB_ON_PRODUCT_MOUNTED', finish); reject(new Error('Customiser took too long to respond.')); }, 45000);
        document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', finish);
      });
      // Attach a handler immediately while external scripts load.
      mounted.catch(() => {});
      for (const script of scripts) await runScript(script);
      host.querySelector('.cpb-payment-buttons')?.remove();
      await mounted;
      loaded = true;
      status.remove();
    })().catch(error => {
      failed = true;
      if (!status.isConnected) host.append(status);
      status.hidden = false;
      status.style.display = 'block';
      message.textContent = 'The customiser could not load. You can retry or return to the product.';
      retry.hidden = false;
      console.warn('[Growplay customiser]', error.message);
      throw error;
    });
    return loading;
  }
  retry.addEventListener('click', () => {
    // Reloading a failed third-party app in place can duplicate its listeners.
    // A customization-intent URL safely restarts the page and retries once.
    const url = new URL(location.href);
    url.searchParams.set('customize', 'true');
    location.assign(url.href);
  });
  window.GrowplayBuilderLoader = { load };
})();
